import React from 'react';
import { FormControl, InputLabel, MenuItem, Select, Paper, Typography, Box } from '@mui/material';

interface FontSelectorProps {
  selectedFont: string;
  onFontChange: (font: string) => void;
}

const availableFonts = [
  { value: 'JetBrains Mono', label: 'JetBrains Mono' },
  { value: 'Roboto Serif', label: 'Roboto Serif' },
  { value: 'Roboto', label: 'Roboto' },
  { value: 'Inter', label: 'Inter' },
  { value: 'Open Sans', label: 'Open Sans' },
  { value: 'Lato', label: 'Lato' },
  { value: 'Source Sans Pro', label: 'Source Sans Pro' },
  { value: 'Montserrat', label: 'Montserrat' },
  { value: 'Poppins', label: 'Poppins' },
  { value: 'Work Sans', label: 'Work Sans' },
  { value: 'IBM Plex Sans', label: 'IBM Plex Sans' },
  { value: 'Fira Sans', label: 'Fira Sans' },
  { value: 'Nunito', label: 'Nunito' },
  { value: 'Merriweather', label: 'Merriweather (Serif)' },
  { value: 'Playfair Display', label: 'Playfair Display (Serif)' },
  { value: 'Georgia', label: 'Georgia' },
  { value: 'Times New Roman', label: 'Times New Roman' },
  { value: 'Arial', label: 'Arial' },
  { value: 'Helvetica', label: 'Helvetica' },
  { value: 'Verdana', label: 'Verdana' },
];

export const FontSelector: React.FC<FontSelectorProps> = ({ selectedFont, onFontChange }) => {
  return (
    <Paper elevation={2} sx={{ p: 2, mb: 3 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <Typography variant="body2" sx={{ minWidth: 'auto', fontWeight: 'bold' }}>
          🎨 Font Style:
        </Typography>
        <FormControl size="small" sx={{ minWidth: 200 }}>
          <InputLabel>Font Family</InputLabel>
          <Select
            value={selectedFont}
            label="Font Family"
            onChange={(e) => onFontChange(e.target.value)}
          >
            {availableFonts.map((font) => (
              <MenuItem 
                key={font.value} 
                value={font.value}
                sx={{ fontFamily: font.value }}
              >
                {font.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
    </Paper>
  );
}; 